export default "__VITE_ASSET__Co_1ISDb__"